import { useEffect, useState } from "react";

import { Table } from "../../../components/Table";
import {
  defaultSliderFilters,
  defaultDropDownFilters,
  defaultMultiDropDownFilters,
  getColumns,
} from "./columnData";
import { useAppSelector } from "../../../store/hooks";
import { filterUniqueKeys } from "../../../services/utils/filterUniqueKeys";
import { Container } from "../Admin.styles";

export const Members = () => {
  const members = useAppSelector(state => state.memberList.members);
  const token = useAppSelector(state => state.auth.token);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [tableData, setTableData] = useState(
    JSON.parse(JSON.stringify(members)) //deep copy the object to make it editable by Table
  );
  const [dropDownFilters, setDropFilters] = useState<any>(null);
  const [multiDropDownFilters, setMultiDropDownFilters] = useState<any>(null);

  useEffect(() => {
    fetchMembers();
  }, [members]);

  const fetchMembers = async () => {
    try {
      const newDropDownFilters = filterUniqueKeys(
        members,
        defaultDropDownFilters,
        Object.keys(defaultDropDownFilters)
      );
      const newMultiFilters = filterUniqueKeys(
        members,
        defaultMultiDropDownFilters,
        Object.keys(defaultMultiDropDownFilters)
      );

      setTableData(JSON.parse(JSON.stringify(members)));
      setDropFilters(newDropDownFilters);
      setMultiDropDownFilters(newMultiFilters);
    } catch (error) {
      console.error("Members fetch:", error);
    }

    //possibly add a time out on the chance there isn't any members
    if (members.length) setIsLoading(false);
  };

  return (
    <Container>
      <Table
        searchable
        title="Members"
        tableType="Members"
        isLoading={isLoading}
        defaultRows={20}
        columns={getColumns(token)}
        rowsPerPage={[10, 20, 35, 50]}
        data={tableData}
        sliderFilters={defaultSliderFilters}
        dropDownFilters={dropDownFilters}
        multiDropDownFilters={multiDropDownFilters}
      />
    </Container>
  );
};
